<ridango-modal [size]="'460'" [isItSmall]="true" [visible]="true" (onCloseModal)="cancelDelete()" #modal>
    <div class="modal-dialog-460__wrapper">
        <h1 id="modal-aria-label" class="modal-dialog-460__title">
            {{ 'ACCOUNT_DELETION_MODAL_TITLE' | translate }}
        </h1>

        <div class="margin-bottom-30">
            <p>{{ 'ACCOUNT_DELETION_MODAL_DESCRIPTION_1' | translate }}</p>
            <p>{{ 'ACCOUNT_DELETION_MODAL_DESCRIPTION_2' | translate }}</p>
            <p>{{ 'ACCOUNT_DELETION_MODAL_LIST_TITLE' | translate }}</p>

            <div class="block--bg-bullets margin-bottom-20 block">
                <ul class="diferent-bullets" innerHtml="{{ 'ACCOUNT_DELETION_MODAL_LIST' | translate }}"></ul>
            </div>

            <p *ngIf="env.ACCOUNT_DELETE_CONFIRM_TYPE === accountDeleteConfirmationType.CONFIRM_WITH_EMAIL">
                {{ 'ACCOUNT_DELETION_MODAL_CONFIRMATION_TEXT' | translate }}
            </p>

            <div *ngIf="env.ACCOUNT_DELETE_CONFIRM_TYPE === accountDeleteConfirmationType.CONFIRM_WITH_TICKBOX">
                <span class="checkbox-wcag">
                    <input
                        type="checkbox"
                        attr.aria-hidden="true"
                        class="checkbox-wcag__checkbox"
                        tabindex="-1"
                        [checked]="accountDeletionConfirmed"
                        attr.aria-label="{{ 'READ_TERMS_CHECKBOX_ARIA_LABEL' | translate }}" />
                    <span
                        class="checkbox-wcag__checkmark"
                        tabindex="0"
                        (click)="toggleDeleteConfirmCheckbox()"
                        (keydown.space)="toggleTerms()"
                        attr.aria-checked="{{ accountDeletionConfirmed }}"
                        role="checkbox"
                        attr.aria-label="{{ 'ACCOUNT_DELETION_MODAL_CONFIRMATION_CHECKBOX_ARIA_LABEL' | translate }}">
                    </span>
                    <label class="checkbox-wcag__label checkbox-wcag__label--large-offset">
                        <span
                            class="link-label"
                            (click)="toggleDeleteConfirmCheckbox()"
                            (keydown.enter)="toggleDeleteConfirmCheckbox()"
                            (keydown.space)="toggleDeleteConfirmCheckbox()">
                            {{ 'ACCOUNT_DELETION_MODAL_CONFIRMATION_CHECKBOX' | translate }}
                        </span>
                    </label>
                </span>
            </div>
        </div>

        <div class="align-center">
            <button
                *ngIf="env.ACCOUNT_DELETE_CONFIRM_TYPE === accountDeleteConfirmationType.CONFIRM_WITH_EMAIL"
                class="btn btn--big btn--primary btn--maximal margin-bottom-20"
                (click)="confirmDelete()"
                (keydown.enter)="confirmDelete()"
                (keydown.space)="confirmDelete()"
                tabindex="0">
                {{ 'ACCOUNT_DELETION_MODAL_BUTTON' | translate }}
            </button>

            <button
                *ngIf="env.ACCOUNT_DELETE_CONFIRM_TYPE === accountDeleteConfirmationType.CONFIRM_WITH_TICKBOX"
                [disabled]="!accountDeletionConfirmed"
                class="btn btn--big btn--primary btn--maximal margin-bottom-20"
                (click)="confirmDeleteWithCheckbox()"
                (keydown.enter)="confirmDeleteWithCheckbox()"
                (keydown.space)="confirmDelete()"
                tabindex="0">
                {{ 'ACCOUNT_DELETION_MODAL_BUTTON' | translate }}
            </button>

            <a
                class="link link--emphasized link--action modal-dialog__cancel-link"
                (click)="cancelDelete()"
                (keydown.enter)="cancelDelete()"
                (keydown.space)="cancelDelete()"
                tabindex="0"
                >{{ 'ACCOUNT_DELETION_MODAL_CANCEL' | translate }}</a
            >
        </div>
    </div>
</ridango-modal>
